import React from "react";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";
import BoxComponent from "../../../components/Box/BoxComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { ResumoGeral } from "../CaixaPage";
import SvgComponent from "../../../components/Image/SvgComponent";
import { ReactComponent as ImpressoraIcon } from "../../../assets/icons/impressora.svg";
import { formatNumberToPtBr } from "../../../utils/numero";
import { formatDateTimePtBr } from "../../../utils/datas";

interface CaixaResumoProps {
    resumo: ResumoGeral;
    onClick: () => void;
}

const CaixaResumoComponent = (props: CaixaResumoProps) => {
    // ESTILIZACAO
    const styleTitle = {
        fontFamily: '"Font 7", sans-serif',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0em',
        color: '#333333',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        textTransform: 'uppercase'
    };

    const styleDescricao = {
        fontFamily: '"Font 7", sans-serif',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0em',
        color: '#666666',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        textTransform: 'uppercase'
    };

    const styleValores = {
        fontFamily: '"Font 7", sans-serif',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0em',
        color: '#333333',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        textTransform: 'none'
    };

    return <BoxComponent
        component="div"
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 1px 2px -1px #0000001A",
            borderRadius: "8px",
            //padding: 2,
            //gap: 1.6,
            flex: 1,
            width: "100%",
        }}
    >
        {/* RESUMO */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid  #E0E0E0",
                width: "100%",
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    py: "10px"
                }}
            >
                <TypographyComponent
                    variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0em',
                        color: '#333333',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle',
                        textTransform: 'uppercase',
                    }}
                >
                    Resumo
                </TypographyComponent>
                <ButtonComponent id="impressora" onClick={props.onClick}>
                    <SvgComponent
                        icon={<ImpressoraIcon />}
                        key={"impressora-icon"}
                        sx={{
                            stroke: "#2A2929"
                        }}
                    />
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>

        {/* SESSÃO */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid  #E0E0E0",
                width: "100%",

            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: "100%",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    gap: 0.2,
                    py: "10px"
                }}
            >
                <TypographyComponent variant="body2"
                    sx={styleTitle}
                >
                    Sessão {props.resumo.sessao.id}
                </TypographyComponent>

                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 500,
                        fontSize: '12px',
                        lineHeight: '16px',
                        letterSpacing: '0em',
                        color: props.resumo.sessao.status === "ABERTO" ? " #4CAF50" : "#E7000B",
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle',
                        textTransform: 'none'
                    }}
                >
                    {props.resumo.sessao.status}
                </TypographyComponent>

                {props.resumo.sessao.status === "ABERTO" && (
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0em',
                            color: '#666666',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'none'
                        }}
                    >
                        Aberto em {formatDateTimePtBr(new Date(props.resumo.sessao.abertoEm))}
                    </TypographyComponent>
                )}
            </BoxComponent>
        </BoxComponent>

        {/* RESUMO DO CAIXA */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                //borderBottom: "1px solid  #E0E0E0",
                width: "100%",
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: "100%",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    gap: 1.2,
                    py: "10px"
                }}
            >
                <TypographyComponent variant="body2" sx={styleTitle}>
                    RESUMO DO CAIXA
                </TypographyComponent>

                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: 0.8
                    }}
                >
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            SALDO INICIAL
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.saldoInicial)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            SUPRIMENTOS
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.suprimentos)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            SANGRIAS
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.sangrias)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            VENDAS EM DINHEIRO
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.vendasDinheiro)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            VENDAS EM DINHEIRO IFOOD
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.vendasDinheiroIfood)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            RECEBIMENTOS FIADO EM DINHEIRO
                        </TypographyComponent>

                        <TypographyComponent variant="body2"
                            sx={styleValores}
                        >
                            {formatNumberToPtBr(props.resumo.resumoCaixa.recebimentosFiadoDinheiro)}
                        </TypographyComponent>
                    </BoxComponent>
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>

        {/* VALOR EM CAIXA */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderTop: "1px solid  #E0E0E0",
                borderBottom: "1px solid  #E0E0E0",
                width: "100%"
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "#F9FAFB",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    gap: 1.2,
                    py: "10px"
                }}
            >
                <TypographyComponent variant="body2"
                    sx={styleTitle}
                >
                    VALOR EM CAIXA
                </TypographyComponent>

                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0em',
                        color: '#FF8C42',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle',
                        textTransform: 'none'
                    }}
                >
                    {formatNumberToDinheiro(props.resumo.resumoCaixa.valorEmCaixa)}
                </TypographyComponent>
            </BoxComponent>
        </BoxComponent>

        {/* RESUMO DE VENDAS */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                //border: "1px solid  #E0E0E0",
                width: "100%"
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    backgroundColor: "#F9FAFB",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    gap: 1.2,
                    py: "10px"
                }}
            >
                <TypographyComponent variant="body2"
                    sx={styleTitle}
                >
                    RESUMO DAS VENDAS
                </TypographyComponent>

                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        border: "transparent",
                        gap: 1
                    }}
                >
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 600,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0em',
                            color: '#666666',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'none'
                        }}
                    >
                        VENDAS iFood
                    </TypographyComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                border: "transparent"
                            }}>
                            <TypographyComponent variant="body2"
                                sx={styleDescricao}
                            >
                                IFOOD (PIX)
                            </TypographyComponent>

                            <TypographyComponent variant="body2" sx={styleValores}>
                                {formatNumberToPtBr(props.resumo.resumoVendas.ifood.pix)}
                            </TypographyComponent>
                        </BoxComponent>

                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                border: "transparent"
                            }}>
                            <TypographyComponent variant="body2"
                                sx={styleDescricao}
                            >
                                IFOOD (VISA)
                            </TypographyComponent>

                            <TypographyComponent variant="body2" sx={styleValores}>
                                {formatNumberToPtBr(props.resumo.resumoVendas.ifood.visa)}
                            </TypographyComponent>
                        </BoxComponent>

                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                border: "transparent"
                            }}>
                            <TypographyComponent variant="body2"
                                sx={styleDescricao}
                            >
                                IFOOD (MASTERCARD)
                            </TypographyComponent>

                            <TypographyComponent variant="body2" sx={styleValores}>
                                {formatNumberToPtBr(props.resumo.resumoVendas.ifood.mastercard)}
                            </TypographyComponent>
                        </BoxComponent>

                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                border: "transparent"
                            }}>
                            <TypographyComponent variant="body2"
                                sx={styleDescricao}
                            >
                                IFOOD (NUBANK)
                            </TypographyComponent>

                            <TypographyComponent variant="body2" sx={styleValores}>
                                {formatNumberToPtBr(props.resumo.resumoVendas.ifood.nubank)}
                            </TypographyComponent>
                        </BoxComponent>
                    </BoxComponent>
                </BoxComponent>

                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        border: "transparent"
                    }}
                >
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 600,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0em',
                            color: '#666666',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'uppercase'
                        }}
                    >
                        PAGAMENTOS OFFLINE
                    </TypographyComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2"
                            sx={styleDescricao}
                        >
                            CRÉDITO (MASTERCARD)
                        </TypographyComponent>

                        <TypographyComponent variant="body2" sx={styleValores}>
                            {formatNumberToPtBr(props.resumo.resumoVendas.pagamentosOffline.creditoMastercard)}
                        </TypographyComponent>
                    </BoxComponent>
                </BoxComponent>

                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    }}
                >
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2" sx={{ ...styleTitle, fontWeight: 300 }}>
                            VALOR DOS PRODUTOS
                        </TypographyComponent>

                        <TypographyComponent variant="body2" sx={styleValores}>
                            {formatNumberToPtBr(props.resumo.resumoVendas.infosAdicionais.valorProdutos)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2" sx={{ ...styleTitle, fontWeight: 300 }}>
                            TAXAS DE ENTREGA
                        </TypographyComponent>

                        <TypographyComponent variant="body2" sx={styleValores}>
                            {formatNumberToPtBr(props.resumo.resumoVendas.infosAdicionais.taxasEntrega)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2" sx={{ ...styleTitle, fontWeight: 300 }}>
                            TAXAS ADICIONAIS
                        </TypographyComponent>

                        <TypographyComponent variant="body2" sx={styleValores}>
                            {formatNumberToPtBr(props.resumo.resumoVendas.infosAdicionais.taxasAdicionais)}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "transparent"
                        }}>
                        <TypographyComponent variant="body2" sx={{ ...styleTitle, fontWeight: 300 }}>
                            DESCONTOS (IFOOD)
                        </TypographyComponent>

                        <TypographyComponent variant="body2" sx={styleValores}>
                            {formatNumberToPtBr(props.resumo.resumoVendas.ifood.descontos)}
                        </TypographyComponent>
                    </BoxComponent>
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>

        {/* TOTAL */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderTop: "1px solid  #E0E0E0",
                borderBottom: "1px solid  #E0E0E0",
                width: "100%"
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "#F9FAFB",
                    //borderBottom: "1px solid  #E0E0E0",
                    px: "16px",
                    gap: 0.4,
                    py: "10px"
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        border: "transparent",
                        width: "100%"
                    }}>
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 600,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0em',
                            color: '#333333',
                            textTransform: 'uppercase',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        TOTAL
                    </TypographyComponent>

                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 600,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0em',
                            color: '#333333',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'none'
                        }}
                    >
                        {formatNumberToPtBr(props.resumo.totalGeral)}
                    </TypographyComponent>
                </BoxComponent>

                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '16px',
                        letterSpacing: '0em',
                        color: '#999999',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle',
                        textTransform: 'none'
                    }}
                >
                    *As vendas iFood não são contabilizadas nos outros resumos.
                </TypographyComponent>
            </BoxComponent>
        </BoxComponent>

        {/* <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%"
            }}
        >
            
        </BoxComponent> */}
    </BoxComponent>
}

export default CaixaResumoComponent;